const BASE_URL = process.env.REACT_APP_API_URL_DEFAULT 
export const LANDING_URL = {
  GetRole: `${BASE_URL}usermanagement/GetUserRoleByEmail`,
  GetRegion: `${BASE_URL}Region`,
};
